<template>
  <div class="other" :class="{'other_mobile': isMobile}">
    <router-link
      v-for="(item, key) in getItems"
      :key="key"
      :to="item.to"
      class="other__item"
    >
      <div
        class="other__icon-wrap"
        :style="{
          'background-color': item.bgColor,
        }"
      >
        <v-icon
          v-if="item.icon"
          class="other__icon"
          :style="{
            'color': item.color,
          }"
        >{{ item.icon }}</v-icon>
        <img v-if="item.img" :src="item.img" class="other__img">
        <div class="other__action"></div>
        <badge-count
          v-if="item.to.name === 'curator'"
          :count="$store.state.chat.unreadMessages"
          :size="30"
          :font-size="16"
          :top="-8"
          :right="-8"
        ></badge-count>
      </div>
      <div class="other__label-wrap">
        {{ item.label }}
      </div>
    </router-link>
  </div>
</template>

<script>
import BadgeCount from "@/components/ui/BadgeCount";

export default {
  components: {BadgeCount},
  props: {
    items: {type: Array, default: () => []},
  },
  computed: {
    getItems() {
      return this.items.filter(item => item.show === undefined || item.show);
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/vars';

.other {
  width: calc(100% + 20px);
  margin-left: -10px;
  display: flex;
  flex-wrap: wrap;

  &.other_mobile {
    justify-content: space-around;
  }
  .other__item {
    margin: 0 10px 10px 10px;
    text-decoration: none;

    :hover {
      .other__action {
        display: block;
      }
    }
  }
  .other__icon-wrap {
    width: 80px;
    height: 80px;
    background-color: $colorPrimary;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .other__icon {
    color: #fff;
    font-size: 50px;
  }
  .other__img {
    width: 50px;
    height: 50px;
  }
  .other__label-wrap {
    width: 80px;
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
    margin-top: 10px;
    font-size: 13px;
  }
  .other__action {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(134, 134, 134, 0.15);
    display: none;
    border-radius: 20px;
  }
}
</style>